import { render, staticRenderFns } from "./EnrollmentUpdateDialog.vue?vue&type=template&id=068f720d&"
import script from "./EnrollmentUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports